import { render } from "./SellerShop.vue?vue&type=template&id=1fafffc0&scoped=true&ts=true&lang=pug"
import script from "./SellerShop.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerShop.vue?vue&type=script&setup=true&lang=ts"

import "./SellerShop.vue?vue&type=style&index=0&id=1fafffc0&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fafffc0"]])

export default __exports__